import { render, staticRenderFns } from "./AsideMenuContainer.vue?vue&type=template&id=3351bce6"
import script from "./AsideMenuContainer.vue?vue&type=script&lang=js"
export * from "./AsideMenuContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports